import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { axiosPublicInstance } from '../../redux/axiosInstance';
import { GET_BREADCRUMBS } from '../../redux/apis';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from '../../classes/Breadcrump';

interface IconBreadcrumbsProps {
    categoryId: number;
}

const IconBreadcrumbs: React.FC<IconBreadcrumbsProps> = ({ categoryId }) => {
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBreadcrumbs = async () => {
            try {
                if (categoryId > 0) {
                    // const endpoint = `${GET_BREADCRUMBS}${categoryId}`;
                    // const response = await axiosPublicInstance.get(endpoint);
                    // const data: Breadcrumb[] = await response.data;
                    // setBreadcrumbs(data);
                    setBreadcrumbs([
                        { categoryId: 1, name: "Electronics", url: "/electronics" },
                        { categoryId: 5, name: "Security & Surveillance", url: "/electronics/security" },
                        { categoryId: 12, name: "CCTV Camera", url: null }
                    ]);
                }
            } catch (error) {
                console.error('Failed to load breadcrumbs:', error);
            }
        };

        fetchBreadcrumbs();
    }, [categoryId]);

    return (
        <Breadcrumbs aria-label="breadcrumb">
            <Link
                underline="hover"
                color="inherit"
                href="/"
                sx={{ display: 'flex', alignItems: 'center' }}
            >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Home
            </Link>
            {breadcrumbs.map((crumb, index) =>
                crumb.url ? (
                    <Link
                        key={index}
                        underline="hover"
                        color="inherit"
                        onClick={(event) => {
                            event.preventDefault();
                            navigate('/productlist', { state: { categoryId: crumb.categoryId } });
                        }}
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    >
                        {crumb.name}
                    </Link>
                ) : (
                    <Typography
                        key={index}
                        color="text.primary"
                        sx={{ display: 'flex', alignItems: 'center' }}
                    >
                        {crumb.name}
                    </Typography>
                )
            )}
        </Breadcrumbs>
    );
};

export default IconBreadcrumbs;
